__turbopack_context__.v({
  "applyBtn": "WDedicatedJobOffers-module__8I6X3q__applyBtn",
  "applyWrap": "WDedicatedJobOffers-module__8I6X3q__applyWrap",
  "body": "WDedicatedJobOffers-module__8I6X3q__body",
  "card": "WDedicatedJobOffers-module__8I6X3q__card",
  "cardDesc": "WDedicatedJobOffers-module__8I6X3q__cardDesc",
  "cardTitle": "WDedicatedJobOffers-module__8I6X3q__cardTitle",
  "ctaBtn": "WDedicatedJobOffers-module__8I6X3q__ctaBtn",
  "ctaCard": "WDedicatedJobOffers-module__8I6X3q__ctaCard",
  "ctaHeading": "WDedicatedJobOffers-module__8I6X3q__ctaHeading",
  "heading": "WDedicatedJobOffers-module__8I6X3q__heading",
  "inner": "WDedicatedJobOffers-module__8I6X3q__inner",
  "list": "WDedicatedJobOffers-module__8I6X3q__list",
  "pill": "WDedicatedJobOffers-module__8I6X3q__pill",
  "pillList": "WDedicatedJobOffers-module__8I6X3q__pillList",
  "root": "WDedicatedJobOffers-module__8I6X3q__root",
  "tech": "WDedicatedJobOffers-module__8I6X3q__tech",
  "techList": "WDedicatedJobOffers-module__8I6X3q__techList",
});
